export { default } from './TextEditor.vue';
